import { Injectable } from "@angular/core";

import { HttpClient } from "@angular/common/http";

import { catchError } from "rxjs/operators";

import { Helpers } from "../../helpers/helpers";

import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

import { ReportService } from "../report.service";

import { ICountService } from "../icount.service";
export interface ReportRequestBody {
  skip: number;
  take: number;
  startDate: string;
  endDate: string;
  asXLS?: boolean;
}

export interface RequestModel {
  date: string;
  numberOfRequests: number;
  numberOfCustomers: number;
  totalIssueFee: number;
  policyFee: number;
  totalAmount: number;
  amountPaid: number;
  basePremium: number;
}

export interface ResponseCount {
  count: number;
}

@Injectable({
  providedIn: "root",
})
export class CarePlusReportService
  extends ReportService
  implements ICountService
{
  constructor(
    protected http: HttpClient,
    helper: Helpers,
    protected snackBar: MatSnackBar
  ) {
    super(http, helper, snackBar);
  }
  getCount(body: ReportRequestBody) {
    return this.http
      .post<ResponseCount>(
        this.pathAPI + `careplus/policy/report/requests/count?IsOrder=false`,
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getData(body: ReportRequestBody) {
    return this.http
      .post<RequestModel[]>(
        this.pathAPI + `careplus/policy/report/requests?IsOrder=false`,
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  downloadReport(body: any, isOrder: boolean) {
    return super.downloadCarePlusReport(body, isOrder);
  }
}
